"use client";

import React from "react";
import Link from "next/link";
import { SanityDocument } from "@sanity/client";
import { SocialIcon } from "react-social-icons/component";
import { navLinks } from "./navigation-bar";
import "react-social-icons/facebook";
import "react-social-icons/tiktok";
import "react-social-icons/instagram";
import "react-social-icons/x";
import "react-social-icons/youtube";

interface FooterProps {
  links: SanityDocument;
}

export const socialMedias = [
  { platform: "facebook" },
  { platform: "instagram" },
  { platform: "x" },
  { platform: "tiktok" },
  { platform: "youtube" },
];

function Footer({ links }: Readonly<FooterProps>) {
  return (
    <footer className="h-64 w-full bg-gradient-to-b from-slate-800 to-slate-900 lg:h-52">
      <section className="mx-auto flex h-full w-full max-w-7xl flex-col-reverse items-center justify-center gap-7 px-5 md:px-10 lg:flex-row lg:justify-between">
        <div className="flex w-full justify-center text-wrap lg:justify-start">
          <span className="text-xs text-cream md:text-base lg:text-xs xl:text-base">
            All rights reserved &copy; Rake Engineering Consultancy
          </span>
        </div>
        <div className="flex gap-5">
          {socialMedias.map(
            ({ platform }) =>
              links[platform] && (
                <SocialIcon
                  target="_blank"
                  rel="noreferrer"
                  key={platform}
                  bgColor="transparent"
                  fgColor="white"
                  network={platform}
                  url={links[platform].url}
                  className="rounded-full border hover:border-highlighter hover:fill-highlighter"
                />
              ),
          )}
        </div>
        <div className="flex w-full items-center justify-center gap-5 text-xs text-cream md:text-base lg:justify-end lg:text-xs xl:text-base">
          {navLinks.map((item) => (
            <Link
              className="hover:text-highlighter"
              key={item.label}
              href={item.link}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </section>
    </footer>
  );
}

export default Footer;
